//TODO: Put a routes vs route name /screen name mapping object here

const routes={
    mainlinks:[
        // {
        //     name:'home',
        //     alias:'dashboard',
        //     url:'/'
        // },
        {
            name:'projects',
            alias:'projects',
            url:'/projects',
        },        
        {
            name:'reels',
            alias:'reels',
            url:'/reels',
        },
        {
            name:'calendar',
            alias:'calendar',
            url:'/calendar',
        },
        {
            name:'participants',
            alias:'participants',
            url:'/participants',
        },
        {
            name:'settings',
            alias:'settings',
            url:'/settings',
        },
        {
            name:'search',
            alias:'search',
            url:'/search',
        }
    ],
    projectlinks:[
        {
            name:'Screener',
            alias:'screener',
            url:'/screener',
            skipDefault:false
        },
        {
            name:'Participants',
            alias:'participants',
            url:'/participants',
            skipDefault:false
        },
        {
            name:'Discussion Guide',
            alias:'script',
            url:'/script',
            skipDefault:true
        },
        {
            name:'Files',
            alias:'sessions',
            url:'/sessions',
            skipDefault:false

        },
        {
            name:'analysis',
            alias:'analysis',
            url:'/analysis?tab=tag',
            skipDefault:true
        },
        {
            name:'Docs',
            alias:'docs',
            url:'/docs',
            skipDefault:true
        },
        // {
        //     name:'AI',
        //     alias:'ai',
        //     url:'/assistants',
        //     skipDefault:true
        // },
        // {
        //     name:'tags',
        //     alias:'tags',
        //     url:'/tags',
        //     skipDefault:false

        // },
    ],
    
}

export default routes;